module.exports = __webpack_public_path__ + "static/media/exo-latin-100.bf228b4f.woff";